module.exports = __webpack_public_path__ + "img/user2.bcebe326.svg";